import { graphql } from 'gql';

export const bimWorkOrderChangeOtherPricesGql = graphql(`
    query bimWorkOrderChangeOtherPrices(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
        $where: BimWorkOrderChangeOtherPriceDataFilterInput
        $order: [BimWorkOrderChangeOtherPriceDataSortInput!]
    ) {
        bimWorkOrderChangeOtherPrices(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            where: $where
            order: $order
        ) {
            items {
                workOrderOtherPriceId
                workOrderChangeOtherPriceId
                contractOtherCostId
                name
                calculatingType
                calculatingTypeValue
                canExcludeRow
                chapter
                section
                status
                planValue {
                    others
                    total
                    hasErrors
                    errors
                }
                completedValue {
                    others
                    total
                    hasErrors
                    errors
                }
                remainderValue {
                    others
                    total
                    hasErrors
                    errors
                }
                hasActAcceptedCost
                isActKC2Price
                isAddedRow
                isRemovedRow
                isExcludedRow
                completedOtherDeviation
                canExcludeRow
                rationale
            }
            totalCount
        }
    }
`);

export const bimWorkOrderChangeOtherNameFilterGql = graphql(`
    query bimWorkOrderChangeOtherNameFilter(
        $workOrderChangeId: Long!
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
        $where: FilterValueOfStringFilterInput
    ) {
        bimWorkOrderChangeOtherNameFilter(
            workOrderChangeId: $workOrderChangeId
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimWorkOrderChangeOtherRemoveGql = graphql(`
    mutation bimRemoveWorkOrderChangeOthers(
        $workOrderChangeId: Long!
        $workOrderChangeOtherPriceIds: [BimWorkOrderChangeOtherPriceIdsInput!]!
    ) {
        bimRemoveWorkOrderChangeOthers(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeOtherPriceIds: $workOrderChangeOtherPriceIds
        ) {
            data {
                itemIds
                workOrderChangeId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderChangeOtherExcludeGql = graphql(`
    mutation bimExcludeWorkOrderChangeOther(
        $workOrderChangeId: Long!
        $workOrderChangeOtherPriceId: BimWorkOrderChangeOtherPriceIdsInput!
    ) {
        bimExcludeWorkOrderChangeOther(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
        ) {
            id
            result
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
